// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-outline-primary.bg-light[data-v-580a6471]:hover{background:var(--primary-color)!important}", ""]);
// Exports
module.exports = exports;
